<!-- 模块验证计划 -->
<template>
    <h-list-page>
        <h-card :title="h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1')" width="100%" :is-left="0" is-search footer @change-method="changeMethod">
            <h-area>
                <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
                    <h-autocomplete popper-class="mlHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
                        :trigger-on-focus="false" @input="() => searchData.mtlNo.length < 4 ? (isShowList = false) : ''"
                        @clear="isShowList = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="myBlur('isShowList')"
                        @focus="myFocus3('isShowList')">
                    </h-autocomplete>
                    <h-detail width="400px" top="34px" left="0px">
                        <el-table v-show="isShowList" v-loading="mtlNoloading" ref="filterTable" :data="mtlNoList" border
                            size="small" max-height="252" @row-click="clickmtlNo" @mousedown="blur = true">
                            <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
                            <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
                        </el-table>
                    </h-detail>
                </h-search>
                <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
                    <h-input v-model="searchData.mtlName" clearable></h-input>
                </h-search>
                <h-search :title="h_i18n('20ed9092e5ca496aa1587d5690021d8f')">
                    <h-input v-model="searchData.templateNo" :placeholder="h_i18n('20ed9092e5ca496aa1587d5690021d8f')" clearable></h-input>
                </h-search>
                <h-search :title="h_i18n('d0b29584322d8496aec3d9184457d6f1')">
                    <h-input v-model="searchData.versionNo" :placeholder="h_i18n('d0b29584322d8496aec3d9184457d6f1')" clearable></h-input>
                </h-search>
                <h-search :title="h_i18n('0c49e608aed336e8aba6c831d0665150')">
                    <h-input v-model="searchData.createFactory" :placeholder="h_i18n('0c49e608aed336e8aba6c831d0665150')" clearable></h-input>
                </h-search>
                <h-search :title="h_i18n('80500fc9d5eb7729d2f489bc92e92e3e')">
                    <h-input v-model="searchData.auditFactory" :placeholder="h_i18n('80500fc9d5eb7729d2f489bc92e92e3e')" clearable></h-input>
                </h-search>
                <h-search :title="h_i18n('b6d0e97218a470eeff7a2bed42b44e21')">
                    <h-select v-model="searchData.status" :placeholder="h_i18n('a8b0c20416853bda54120bf19477ad11')" clearable>
                        <h-option key="4" :label="h_i18n('871a30c0993c4e2a71557fe7f38807c0')" value="4"></h-option>
                        <h-option key="7" :label="h_i18n('3a3ae28c26a97e892eb1d688dacf0e80')" value="7"></h-option>
                        <h-option key="8" :label="h_i18n('d3c33b086a8bee641f066870305a9a77')" value="8"></h-option>
                    </h-select>
                </h-search>
                <h-search :title="h_i18n('a094e5b7699ea4b61094cc4120170423')">
                    <h-select v-model="searchData.dataFrom" :placeholder="h_i18n('a8b0c20416853bda54120bf19477ad11')" clearable>
                        <h-option key="1" :label="h_i18n('3cfbd76af738e1ad6ed9b5e96035f27c')" :value="h_i18n('3cfbd76af738e1ad6ed9b5e96035f27c')"></h-option>
                        <h-option key="2" label="system" value="system"></h-option>
                        <h-option key="3" :label="h_i18n('bab268d5468de413a7158920799e354d')" :value="h_i18n('bab268d5468de413a7158920799e354d')"></h-option>
                    </h-select>
                </h-search>
                <h-search :title="h_i18n('bfbad1baf6af69d9f4db37efafc64cec')">
                    <h-date-picker @change="
                        TimeChange(inputDate, {
                            start: 'beginIsrtDate',
                            end: 'endIsrtDate'
                        })
                        " v-model="inputDate" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')"
                        :clearable="clearAble" />
                </h-search>
                <h-search :title="h_i18n('5b92e71e2c8c6b17af7d817a72306678')">
                    <h-date-picker @change="
                        TimeChange(inputDate2, {
                            start: 'beginAuditDate',
                            end: 'endAuditDate'
                        })
                        " v-model="inputDate2" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')"
                        :clearable="clearAble" />
                </h-search>
                <template #operate>
                    <h-button type="primary" :loading="loading" @click="handleCurrentChange(1)">
                        <template #icon>
                            <search />
                        </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
                </template>
                <!-- <template #reset>
                    <h-button type="default" :loading="tableListLoading">
                        <template #icon>
                            <refresh />
                        </template>
                        重置
                    </h-button>
                </template> -->
            </h-area>
        </h-card>
        <h-table-card :title="h_i18n('176ac03109e9091a19319dbf7591e720')">
            <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" ref="tableDatatable" v-loading="loading"
                @selection-change="handleSelectionbotChange" border :data="tableData" size="small" height="540"
                style="width: 100%;min-height: 540px">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
                <el-table-column prop="templateNo" :label="h_i18n('20ed9092e5ca496aa1587d5690021d8f')" min-width="200">
                    <template #default="scope">
                        <div>
                            <a @click="goDetail(scope.row)" style="color:#3A8EE6;cursor:pointer">{{
                                scope.row.templateNo }}</a>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="versionNo" :label="h_i18n('d0b29584322d8496aec3d9184457d6f1')" min-width="80"> </el-table-column>
                <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="150"></el-table-column>
                <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" min-width="130"></el-table-column>
                <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" min-width="120"></el-table-column>
                <el-table-column prop="supplyName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" min-width="200"></el-table-column>
                <el-table-column prop="createFactory" :label="h_i18n('0c49e608aed336e8aba6c831d0665150')" width="100"></el-table-column>
                <el-table-column prop="isrtEmpName" :label="h_i18n('d4285acb6dcce029eedc17f32a2bb8d1')" width="80"></el-table-column>
                <el-table-column prop="isrtDate" :label="h_i18n('bfbad1baf6af69d9f4db37efafc64cec')" width="100" :formatter="dealDate">
                </el-table-column>
                <el-table-column prop="auditFactory" :label="h_i18n('80500fc9d5eb7729d2f489bc92e92e3e')" width="100"></el-table-column>
                <el-table-column prop="auditEmpName" :label="h_i18n('82da895cd022775edf8ccb40b8f79e8f')" width="80"></el-table-column>
                <el-table-column prop="auditDate" :label="h_i18n('5b92e71e2c8c6b17af7d817a72306678')" width="100" :formatter="dealDate">
                </el-table-column>
                <el-table-column prop="status" :label="h_i18n('b6d0e97218a470eeff7a2bed42b44e21')" width="120">
                    <template #default="scope">
                        <div v-if="scope.row.status==='2'">{{ h_i18n('ec0e35a2a24f46d6f1dede71a6ea43e4') }}</div>
                        <div v-if="scope.row.status==='3'">
                            <span v-if="scope.row.mine==='Y'">{{ h_i18n('d1fac8c96737bca4dca0ac1ef0b35349') }}</span>
                            <span v-else>{{ h_i18n('5cb424765cb101866f47ca115605ce3b') }}</span>
                        </div>
                        <div v-if="scope.row.status==='4'">{{ h_i18n('871a30c0993c4e2a71557fe7f38807c0') }}</div>
                        <div v-if="scope.row.status==='5'">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</div>
                        <div v-if="scope.row.status==='7'">{{ h_i18n('3a3ae28c26a97e892eb1d688dacf0e80') }}</div>
                        <div v-if="scope.row.status==='8'">{{ h_i18n('d3c33b086a8bee641f066870305a9a77') }}</div>
                    </template> 
                </el-table-column>
                <el-table-column prop="deleteStatus" :label="h_i18n('94d8077aa84fc7122349fac0453dccc6')" width="100">
                    <template #default="scope">
                        <span>
                            {{ scope.row.status == "4" || scope.row.status == "7" ? h_i18n('c6cc397661432878e10a24834460da0d') : scope.row.status == "8" ? h_i18n('1abbb1748ef98f00486f7801a290fdb4') :
                                '' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="dataFrom" :label="h_i18n('a094e5b7699ea4b61094cc4120170423')" width="150"></el-table-column>
            </el-table>
            <el-pagination background @current-change="handleCurrentChange" v-model:current="pagenation.current"
                v-model:currentPage="pagenation.current" :page-size="50" layout="total, prev, pager, next,jumper"
                :total="total"></el-pagination>
        </h-table-card>
    </h-list-page>
</template>



  <script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from "moment";
export default {
    data() {
        return {
            keepalivestatus: 0,
            expents: true, // 更多查询条件按钮判断
            pagenation: {
                current: 1,
                size: 50,
            },
            total: 0,
            loading: false,
            fanye: false,
            assessStatusList: [],
            chargeButList: [], // 权限判断
            roleCode: "",
            supplyCode: "",
            vmiList: [],
            mtlNoList: [],
            mtlNoList2: [],
            checkLevelList: [],
            isShowList: false,
            isShowList2: false,
            mtlNoloading: false,
            mtlNoloading2: false,
            supplierList: [],
            isShowsupplierList: false,
            blur: false,
            blur2: false,
            EXportloading: false,
            tipOf600: false,
            //new--------------------
            tableData: [],
            buttonList: [],//按钮权限
            dataTable: {//外检经理
                iqcManagerId: '',
                iqcManagerName: ''
            },
            inputDate: '',
            inputDate2: '',
            checkManagerId: '',
            searchData: {
                supplyCode: '',
                mtlNo: ''
            }, // 查询条件数据
            multipleSelection: [], // 复选框选中
            planeDetails: {
                title: h_i18n('536677329125ba2ffae5a6ded711ddc6'),
                show: false,
                mtlNo: '',
                sybName:'',
                sybId: '',
                supplyCodeList:[],
               
            }, 
            supplyInfoList: [],//供应商列表
            plList: [],//产业 数据
            sybList: [],//小微 数据
            fengongTaskId: '',
        };
    },
    methods: {
    h_i18n,
        dealDate(row, column, cellValue, index) { // 处理时间格式
            return row[column.property] ? moment(row[column.property]).format("YYYY-MM-DD") : ""
        },
        dealStatus(row, column, cellValue, index) {//row, column, cellValue, index
            //(1:暂存；2：HMQM已提交，SQM待完善；3：SQM已提交；4：审核通过；5：驳回）
            let arr = [{ key: 1, value: h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }, { key: 2, value: h_i18n('197be9630128dc95a64c249971698c04') },
            { key: 3, value: h_i18n('5cb424765cb101866f47ca115605ce3b') }, { key: 4, value: h_i18n('871a30c0993c4e2a71557fe7f38807c0') }, { key: 5, value: h_i18n('32525478cd5c1c93de9c71246021b595') }, { key: 7, value: h_i18n('3a3ae28c26a97e892eb1d688dacf0e80') }]
            let filteList = arr.filter(item => item.key == row[column.property])
            return filteList.length ? filteList[0].value : ""
        },
        // downLoadFile(uuid, fileName) {
        //     this.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
        //     this.httpFile({
        //         method: 'get',
        //         // url: '/unload/downloadFromOSS',
        //         url: '/unload/downLoadFileNewFtp',
        //         headers: { 'content-type': 'application/json' },
        //         params: { filePath: uuid },
        //     }, fileName)
        // },
        addTemplateRole() {
            this.planeDetails.show = true
        },
        // 展开收起高度改变
        changeMethod() {
            this.changeHeight()
        },
        clicksupplierCode(row) {
            this.blur = true;
            this.searchData.supplyCode = row.supplyCode;
            this.isShowsupplierList = false;
        },
        clearsupplierCode() {
            this.isShowsupplierList = false;
        },
        // 列表复选框事件
        handleSelectionbotChange(val) {
            this.multipleSelection = val;
        },
        //工厂下拉
        changeSyList(data) {
        if(data){
            let list = this.sybList.filter(v => v.sybId === data)
            console.log(list)
            this.planeDetails.sybName = list[0].sybName
            this.planeDetails.sybId = list[0].sybId
        }else{
            this.planeDetails.sybName = ''
            this.planeDetails.sybId = ''
        }
        
        },
        // 时间范围选择
        TimeChange(date, { start, end }) {
            if (date) {
                this.searchData[start] = this.time(date[0]);
                this.searchData[end] = this.time(date[1]);
            } else {
                this.searchData[start] = undefined;
                this.searchData[end] = undefined;
            }
        },
        // 分页
        handleCurrentChange(val) {
            this.pagenation.current = val;
            if (!this.fanye) {
                this.fanye = true;
                this.queryData(val);
            } else {
                return false;
                console.log("无效翻页");
            }
        },
        // 查询方法
        queryData() {
            this.loading = true;
            let params = { ...this.searchData };
            // if (params.generationDate) {
            //     params.generationDate = moment(params.generationDate).format("YYYY-MM-DD");
            // }
            this.$http({
                method: "post",
                // url: '/base/supervisePlan/page',
                url: '/base/baseShipmentTemplate/page',
                data: {
                    ...this.pagenation,
                    ...params,
                    name: this.$route.query.name,
                    nickName: this.$route.query.nickName,
                    supplyCode:this.$route.query.supplyCode,
                    deleteStatus:'Y',
                    
                },
            }).then((res) => {
                this.loading = false;
                this.fanye = false;
                console.log(res, '列表数据')
                if (res.data.success) {
                    this.tableData = res.data.data.records
                    this.total = res.data.data.total;
                } else {
                    this.tableData = [];
                    this.total = 0;
                }
            })
        },
        closePlan() {//close --分工
            this.planeDetails.show = false
            this.inspectionManagerList = []
            this.dataTable = {}
            this.checkManagerId = ""
            this.dataTable.iqcManagerId = ""
            this.dataTable.iqcManagerName = ""
        },

        //taskID权限
        taskQuery(id, v) {
            let bool;
            return this.$http({
                method: 'POST',
                url: '/base/processNode/selectTaskId',
                headers: { 'content-type': 'application/json' },
                data: {
                    instanceId: id,
                    createUserName: this.$route.query.name,
                    activityName: v ? v : ''
                },
            }).then((res) => {
                return res.data
            })

        },
        goDetail(row) {
            this.$router.push({
                name: "FactoryTemplateSqmTemplateDetail",
                query: {
                    name: this.$route.query.name,
                    nickName: this.$route.query.nickName,
                    dataFrom: this.$route.query.dataFrom,
                    supplyCode: this.$route.query.supplyCode,
                    type:1,//2审核
                    data:JSON.stringify(row)
                },
            });
        },
        userInfoMessage(id, code, roleCode) {
            this.$http({
                method: 'post',
                url: '/base/processNode/selectProcessNodeList',
                headers: { 'content-type': 'application/json' },
                data: {
                    instanceId: id,
                    activityName: code ? code : '',
                    role: roleCode ? roleCode : ''
                },
                // data: { userId: text, sybId: 9042 },

            }).then(res => {
                console.log(res, '权限res')
                this.info(`${h_i18n('a947d9024ff22abc6e527849e1f2ce67')}${res.data.data[0].createDisplayName},${res.data.data[0].createUserName}${h_i18n('8cfb80454e71bdc8bc9497890b127d37')}`)
            })
        },
        //检验经理查询inspectionManagerList
        inspectionManager(text) {
            this.inspectionManagerList = []
            this.inspectionManagerLoading = true
            this.$http({
                method: 'post',
                url: '/base/cycleCheck/searchUserByCode',
                headers: { 'content-type': 'application/json' },
                data: { userId: text, sybId: this.multipleSelection[0].sybId },
                // data: { userId: text, sybId: 9042 },

            }).then((res) => {
                console.log(res, '外检经理res')
                if (res.data.success) {
                    this.inspectionManagerList = res.data.data
                    this.inspectionManagerLoading = false
                }
            }).catch((err) => {
                // this.error("查询数据失败" + this.errorDispose(err.response.data || err.response || err))
                this.inspectionManagerLoading = false
            })
        },
        //新增-确定
        mySubmit() {
            console.log(this.planeDetails)
            if (!this.planeDetails.sybId  || !this.planeDetails.mtlNo || !this.planeDetails.supplyCodeList.length) {
                this.info(h_i18n('c4a1f4e9af53b17b014775bca8e9c240'))
                return false
            }
            let strMto =  this.planeDetails.mtlNo.indexOf("/")
            let setCode = this.planeDetails.supplyCodeList.map(item=>item.split('/')[0]).toString()
            let list = {
                mtlNo : this.planeDetails.mtlNo.substring(0,strMto),
                mtlName:this.planeDetails.mtlNo.substring(strMto+1,this.planeDetails.mtlNo.length),
                sybName:this.planeDetails.sybName,
                setCode
            }
            console.log(list)
            this.$router.push({
                name: "FactoryTemplateHmqmTemplateAdd",
                query: {
                    name: this.$route.query.name,
                    nickName: this.$route.query.nickName,
                    mtlNo : this.planeDetails.mtlNo.substring(0,strMto),
                    data:JSON.stringify(list)
                },
            });
        },
        //供应商代码模糊查找
        supplierCodeChange() {
            this.blur = false;
            if (this.searchData.supplyCode.length < 2) {
                this.isShowsupplierList = false;
            } else {
                this.mtlNoloading = true;
                this.isShowsupplierList = true;
                this.$http({
                    method: "post",
                    url: "/base/basicData/searchSupplierList",
                    headers: { "content-type": "application/json" },
                    data: {
                        supplyCode: this.searchData.supplyCode,
                    },
                    //   cancelToken: this.http.supplySearchHttp.token
                }).then((res) => {
                    this.supplierList = res.data.data;
                    this.mtlNoloading = false;
                }).catch(e => {
                });
            }
        },
        //专用号模糊查找
        mtlNoChange(queryString, cb) {
            let this_ = this;
            this_.blur = false;
            if (this_.searchData.mtlNo.length < 4) {
                this_.isShowList = false;
            } else {
                this_.mtlNoloading = true;
                this_.isShowList = true;
                this_
                    .$http({
                        method: "post",
                        url: "/base/basicData/searchMaterielList",
                        headers: { "content-type": "application/json" },
                        data: {
                            mtlNo: this.searchData.mtlNo,
                        },
                    })
                    .then((res) => {
                        this_.mtlNoList = res.data.data;
                        this_.mtlNoloading = false;
                    });
            }
        },
        //专用号
        clickmtlNo(row) {
            this.blur = true;
            this.searchData.mtlNo = row.mtlNo;
            this.isShowList = false;
        },
        clearmtlNo() {
            this.isShowList = false;
        },
        myBlur(v) {
            if (!this.blur) {
                this[v] = false;
            }
        },
        myFocus3(v) {
            this.blur = false;
            if (this.searchData.mtlNo.length >= 4) {
                this[v] = true;
            }
        },
        myFocus4(v) {
            this.blur = false;
            if (this.searchData.supplyCode.length >= 4) {
                this[v] = true;
            }
        },
        //新增专用号模糊查找
        mtlNoChange2(v) {
            console.log('mtlNoChange2mtlNoChange2', v, this.planeDetails)
            let this_ = this;
            this_.blur2 = false;
            if (this_.planeDetails.mtlNo.length < 4) {
                this_.isShowList2 = false;
            } else {
                this_.mtlNoloading2 = true;
                this_.isShowList2 = true;
                this_
                    .$http({
                        method: "get",
                        url: "/base/baseShipmentTemplate/mtlInfo?mtlNo=" + this.planeDetails.mtlNo,
                        headers: { "content-type": "application/json" },
                    })
                    .then((res) => {
                        // console.log(res,'新增专用号')
                        this_.mtlNoList2 = res.data.data;
                        this_.mtlNoloading2 = false;
                    });
            }
        },
        inputMtlNo(v) {
            console.log('inputmo', v, this.planeDetails.mtlNo)
        },
        //专用号
        clickmtlNo2(row) {
            console.log(row)
            this.blur2 = true;
            this.planeDetails.mtlNo = row.mtlNo + '/' + row.mtlName;
            this.isShowList2 = false;
            this.$http({
                method: "get",
                url: "/base/baseShipmentTemplate/supplyInfo?mtlNo=" + row.mtlNo,
                headers: { "content-type": "application/json" },
            })
                .then((res) => {
                    if (res.data.success) {
                        this.supplyInfoList = res.data.data
                    }
                    console.log(res, '新增-供应商列表')
                });
        },
        clearmtlNo2() {
            this.isShowList2 = false;
        },
        myBlur2(v) {
            if (!this.blur2) {
                this[v] = false;
            }
        },
        myFocusAdd(v) {
            this.blur2 = false;
            if (this.planeDetails.mtlNo.length >= 4) {
                this[v] = true;
            }
        },
        //时间截取
        formDate(val, len = 3) {
            if (val) {
                return this.time(val, len)
            } else {
                return ""
            }
        },
        //产品线 小微数据 查询 //产业
        productLines() {
            this.$http({
                url: '/base/common/getQuerySybList?userCode=' + this.$route.query.name+'&supplyCode='+this.$route.query.supplyCode,
                method: "get",
            }).then((res) => {
                console.log(res, '小微')
                if (res.data) {
                    this.sybList = res.data.data
                }
            })
        },
        //外检经理--选择
        inspectionManagerChange(data) {
            let arr = data.split("-")
            this.checkManagerId = data
            this.dataTable.iqcManagerId = arr[0]
            this.dataTable.iqcManagerName = arr[1]
        },
    },
    mounted() {
        if(this.$route.query.mtlNo){
            this.searchData.mtlNo = this.$route.query.mtlNo
        }
        this.queryData()//列表数据
        this.changeHeight()//高度
        this.productLines()
    },
    activated() {
        console.log("keepalive-activated");
        this.postThisPageHeight()
        if (this.keepalivestatus == 0) {
            // console.log("首次打开");
        } else {
            // console.log("操作完之后打开");
            this.queryData();

        }
    },
    deactivated() {
        console.log('deactived----')
        this.keepalivestatus = this.keepalivestatus + 1;
    },

};
</script>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
.mlHidden {
    display: none !important;
}

.mlHidden {
    display: none;
}
</style>